import type { TerritorialInspectionSummary } from "@/types/territorial-inspection";
import { ConfidenceBadge, FieldValidationStatusBadge, ProcessingStatusBadge } from "./TerritorioBadges";

interface InspectionsTableProps {
  inspections: TerritorialInspectionSummary[];
  onOpen: (inspection: TerritorialInspectionSummary) => void;
}

export default function InspectionsTable({ inspections, onOpen }: InspectionsTableProps) {
  return (
    <div className="overflow-x-auto border border-background-200/70 rounded-card">
      <table className="w-full text-xs">
        <thead>
          <tr className="bg-background-50 border-b border-background-200/70">
            <th className="text-left px-3 py-2.5 font-medium text-foreground-600 whitespace-nowrap">Código</th>
            <th className="text-left px-3 py-2.5 font-medium text-foreground-600 whitespace-nowrap">Bairro</th>
            <th className="text-left px-3 py-2.5 font-medium text-foreground-600 whitespace-nowrap">Quadra</th>
            <th className="text-left px-3 py-2.5 font-medium text-foreground-600 whitespace-nowrap">Data</th>
            <th className="text-left px-3 py-2.5 font-medium text-foreground-600 whitespace-nowrap">Origem</th>
            <th className="text-left px-3 py-2.5 font-medium text-foreground-600 whitespace-nowrap">Status</th>
            <th className="text-left px-3 py-2.5 font-medium text-foreground-600 whitespace-nowrap">Confiança</th>
            <th className="text-left px-3 py-2.5 font-medium text-foreground-600 whitespace-nowrap">Validação de campo</th>
            <th className="text-center px-3 py-2.5 font-medium text-foreground-600 whitespace-nowrap">Ações</th>
          </tr>
        </thead>
        <tbody>
          {inspections.map((inspection) => (
            <tr
              key={inspection.uuid}
              className="border-b border-background-100 hover:bg-background-50/50 transition-colors"
            >
              <td className="px-3 py-2.5 font-mono text-foreground-800">{inspection.inspectionCode}</td>
              <td className="px-3 py-2.5 text-foreground-700 max-w-[160px] truncate">{inspection.neighborhood || "—"}</td>
              <td className="px-3 py-2.5 text-foreground-700">{inspection.blockCode || "—"}</td>
              <td className="px-3 py-2.5 text-foreground-500 whitespace-nowrap">
                {new Date(inspection.inspectionDate).toLocaleDateString("pt-BR")}
              </td>
              <td className="px-3 py-2.5 text-foreground-600">{inspection.sourceType}</td>
              <td className="px-3 py-2.5"><ProcessingStatusBadge status={inspection.processingStatus} /></td>
              <td className="px-3 py-2.5"><ConfidenceBadge score={inspection.confidenceScore} /></td>
              <td className="px-3 py-2.5"><FieldValidationStatusBadge status={inspection.fieldValidationStatus} /></td>
              <td className="px-3 py-2.5 text-center">
                <button
                  onClick={() => onOpen(inspection)}
                  className="w-7 h-7 rounded-lg flex items-center justify-center hover:bg-background-100 transition-colors cursor-pointer mx-auto"
                  title="Abrir detalhe"
                >
                  <i className="ri-eye-line text-foreground-500 text-sm" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
